import Grid from "@mui/material/Grid";

import Board from "../Analyser/Board";
import importAnswers from "../UserTimeline/ROM/importAnswers";
import useBeeps from "../UserTimeline/useBeeps";

export default function Moodboard({
  variant,
  index,
  board,
  beepIds,
  sentBeeps,
}) {
  const { beeps } = useBeeps(beepIds);
  const rom = beeps ? importAnswers({ ...beeps, sentBeeps }) : undefined;

  return (
    <Grid item xs={12} md={board.size}>
      <Board
        variant={variant}
        waitBeforeShow={index * 400}
        rom={rom}
        item={board}
      />
    </Grid>
  );
}
